import { NavLink, ThemeIcon } from '@mantine/core';
import { IconBus } from '@tabler/icons';
import { AppRoutePaths } from '../../../utils/enums/routes';

interface EmployeeTransportLinkProps {
  navigate(route: string): void;
}

export function EmployeeTransportLink({
  navigate,
}: EmployeeTransportLinkProps) {
  return (
    <NavLink
      styles={{
        label: {
          color: '#373A40',
        },
      }}
      label="Vale Transporte"
      fw="bold"
      color=""
      icon={
        <ThemeIcon color="grape.8" variant="light">
          <IconBus size={16} />
        </ThemeIcon>
      }
      childrenOffset={28}
    >
      <NavLink
        label="Listagem"
        onClick={() => navigate(AppRoutePaths.EMPLOYEE_TRANSPORT)}
      />
    </NavLink>
  );
}
